import { defineMessages } from "react-intl";

const messages = defineMessages({
  submit: {
    id: "riskManagement.components.threshold.submit",
    defaultMessage: "Submit",
  },
  threshold: {
    id: "riskManagement.components.threshold.value",
    defaultMessage: "Threshold Value",
  },
  success: {
    id: "riskManagement.components.threshold.success",
    defaultMessage: "Threshold value updated",
  },
  errorHeader: {
    id: "riskManagement.components.threshold.error.header",
    defaultMessage: "Unable to manage threshold",
  },
  errorBody: {
    id: "riskManagement.components.threshold.error.body",
    defaultMessage:
      "Refresh the page and if issue persists contact the Apex Business Automation Team",
  },
});

export default messages;
